import { COLORS, FONTS } from "@constants";
import { renderMarkdownText } from "@utils/textUtils";
import styled from "styled-components";

export default function SitewideBanner() {
  const { markdown, backgroundColor, color } = gon.sitewide_banner;

  return (
    <Container $backgroundColor={backgroundColor} $color={color}>
      {renderMarkdownText(markdown, { p: { fontSize: "12px", fontWeight: 500 } })}
    </Container>
  );
}

const Container = styled.div<{ $backgroundColor?: string; $color?: string }>`
  width: 100%;
  text-align: center;

  background: ${(props) => props.$backgroundColor ?? COLORS.ORANGE_100};
  color: ${(props) => props.$color ?? COLORS.ORANGE_900};
  font-size: 12px;

  padding: 12px 0;

  ${FONTS.SEMIBOLD_3};
`;
